import * as Yup from 'yup';

const baseValidation = {
  holderName: Yup.string().required('Nome é obrigatório'),
  holderDocument: Yup.string().required('CPF é obrigatório'),
  holderPhone: Yup.string().required('Telefone é obrigatório'),
  postalCode: Yup.string().required('CEP é obrigatório'),
  street: Yup.string().required('Endereço é obrigatório'),
  streetNumber: Yup.string().required('Número é obrigatório'),
  complement: Yup.string().optional(),
  district: Yup.string().required('Bairro é obrigatório'),
  city: Yup.string().required('Cidade é obrigatória'),
  state: Yup.string().required('Estado é obrigatório'),
  expirationDate: Yup.string().required('Data de validade é obrigatória'),
  documents: Yup.string().nullable().optional(),
  licensePlate: Yup.string().required('Placa é obrigatória'),
  vehicleBrand: Yup.string().required('Marca do veículo é obrigatória'),
  vehicleColor: Yup.string().required('Cor do veículo é obrigatória'),
  restricted: Yup.number().required('Delimitação é obrigatória').min(0).max(1),
  observation: Yup.string()
    .nullable()
    .when('restricted', {
      is: 1,
      then: (schema) =>
        schema.required('Delimitação é obrigatória quando ativada.'),
      otherwise: (schema) => schema.notRequired(),
    }),
  routes: Yup.array()
    .of(Yup.number())
    .when('restricted', {
      is: 1,
      then: (schema) =>
        schema.min(1, 'Trecho(s) da delimitação é obrigatório quando ativado.'),
      otherwise: (schema) => schema.optional(),
    }),
};

export const createValidation = Yup.object().shape({
  ...baseValidation,
});

export const updateValidation = Yup.object().shape({
  ...baseValidation,
  number: Yup.number().required('Número da credencial é obrigatório'),
});

/** @deprecated Use createValidation or updateValidation */
export const validation = createValidation;
